<template>
  <div style="margin: 10px; height: 700px">
    <v-form direction="horizontal">
      <div style="text-align: left">
        <v-affix :offset-top="10">
          <v-button type="success" icon="save" @click.prevent="save()"
            >保存</v-button
          >
          <!-- <v-button type="error" icon="close-circle-o" @click="cancel"
          >取消</v-button
        > -->
        </v-affix>
      </div>
      <v-form-item
        label="工号"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input
          v-model="options.gh"
          placeholder="工号"
          v-bind:disabled="gh_dis"
        ></v-input>
      </v-form-item>
      <v-form-item
        label="姓名"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.xm" placeholder="姓名"></v-input>
      </v-form-item>
      <v-form-item
        label="身份证号码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.sfzhm" placeholder="身份证号码"></v-input>
      </v-form-item>
      <v-form-item
        label="职位"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.zw" placeholder="职位"></v-input>
      </v-form-item>
      <v-form-item
        label="入驻单位"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-select
          style="width: 100%"
          :data="khbh_options"
          v-model="options.khbh"
          @change="khbhchange"
        ></v-select>
      </v-form-item>
      <v-form-item
        label="地区"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-select
          style="width: 100%"
          :data="khdq_options"
          v-model="options.khdq"
          @change="khdqchange"
        ></v-select>
      </v-form-item>
      <v-form-item
        label="分组"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-select
          style="width: 100%"
          :data="khfz_options"
          v-model="options.khfz"
          @change="khfzchange"
        ></v-select>
      </v-form-item>
      <v-form-item
        label="考勤规则"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-select
          style="width: 100%"
          :data="kqgz_options"
          v-model="options.kqgz"
        ></v-select>
      </v-form-item>
      <v-form-item
        label="是否审批人员"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-radio-group
          v-model="options.wbry"
          :data="wbry_options"
        ></v-radio-group>
      </v-form-item>
      <v-form-item
        label="入职日期"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-date-picker
          style="width: 100%"
          v-model="options.rzrq"
          clearable
          size="lg"
          format="yyyy-MM-dd"
          position="absolute"
        ></v-date-picker>
      </v-form-item>
      <v-form-item
        label="离职日期"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-date-picker
          style="width: 100%"
          v-model="options.lzrq"
          clearable
          size="lg"
          format="yyyy-MM-dd"
          position="absolute"
        ></v-date-picker>
      </v-form-item>
      <v-form-item
        label="联系电话"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.lxdh" placeholder="联系电话"></v-input>
      </v-form-item>
      <v-form-item
        label="性别"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-select
          style="width: 100%"
          :data="xb_options"
          v-model="options.xb"
        ></v-select>
      </v-form-item>
      <v-form-item
        label="城市"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.cs" placeholder="城市"></v-input>
      </v-form-item>
      <v-form-item
        label="登入类型"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-select
          style="width: 100%"
          :data="dllx_options"
          v-model="options.dllx"
        ></v-select>
      </v-form-item>
      <v-form-item
        label="登入用户名"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.yhm" placeholder="登入用户名"></v-input>
      </v-form-item>
      <v-form-item
        label="登入密码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        v-show="showGroup"
        has-feedback
        required
      >
        <v-input
          type="password"
          v-model="options.mm"
          placeholder="登入密码"
          v-show="showGroup"
        ></v-input>
      </v-form-item>
      <v-form-item
        label="确认密码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        v-show="showGroup"
        has-feedback
        required
      >
        <v-input
          type="password"
          v-model="options.qrmm"
          placeholder="确认密码"
          v-show="showGroup"
        ></v-input>
      </v-form-item>
      <v-form-item
        label="启用"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-switch v-model="options.xybz"></v-switch>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
import jquery from "../../../../static/js/jquery1.11.1";
let options = {
  gh: "",
  xm: "",
  sfzhm: "",
  rzrq: "",
  zw: "",
  lxdh: "",
  khbh: "",
  lzrq: "",
  xb: "",
  cs: "",
  yhm: "",
  mm: "",
  qrmm: "",
  dllx: "",
  // js: "",
  xybz: true,
  khdq: "",
  khfz: "",
  kqgz: "",
  wbry: "0",
};
export default {
  data() {
    return {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      xb_options: [
        {
          value: "1",
          label: "男",
        },
        {
          value: "2",
          label: "女",
        },
      ],
      wbry_options: [
        { text: "否", value: "0" },
        { text: "是", value: "1" },
      ],
      dllx_options: [
        {
          value: "1",
          label: "全部",
        },
        {
          value: "2",
          label: "小程序",
        },
        {
          value: "3",
          label: "web端",
        },
      ],
      khbh_options: [],
      // js_options: [],
      khdq_options: [],
      khfz_options: [],
      kqgz_options: [],
      options,
      bjkhbh: "",
      bjkhdq: "",
      gh_dis: false,
      showGroup: true,
    };
  },
  created() {
    this.init_khbh();
    this.init_kqgz();
    // this.init_js();
    if (this.$route.query.gh) {
      this.init();
      this.gh_dis = true;
      this.showGroup = false;
    }
  },
  methods: {
    init: function () {
      this.$axios
        .get("api/system/rywh/get-rywh-first?gh=" + this.$route.query.gh)
        .then((res) => {
          debugger;
          this.bjkhbh = res.data.data[0].khbh;
          this.bjkhdq = res.data.data[0].khdq;
          // this.options.khbh = res.data.data[0].khbh;
          // this.options.khdq = res.data.data[0].khdq;
          // this.options.khfz = res.data.data[0].khfz;
          this.options = res.data.data[0];
          if (res.data.data[0].xybz == 1) {
            this.options.xybz = true;
          } else {
            this.options.xybz = false;
          }
        });
    },
    init_khbh: function () {
      this.$axios.get("api/system/rywh/get-rywh-khbh").then((res) => {
        let self = this;
        self.khbh_options = res.data.map((item) => {
          return { value: item.khbh, label: item.khbh + "-" + item.khjc };
        });
      });
    },
    init_kqgz: function () {
      this.$axios.get("api/system/rywh/get-rywh-kqgz").then((res) => {
        let self = this;
        self.kqgz_options = res.data.map((item) => {
          return { value: item.gzdm, label: item.gzmc };
        });
      });
    },
    khbhchange: function (result) {
      if (this.bjkhbh != result) {
        this.options.khdq = "";
        this.bjkhbh = result;
        this.options.khfz = "";
      }
      this.$axios
        .get("api/system/rywh/get-rywh-khdq?khbh=" + this.options.khbh)
        .then((res) => {
          let self = this;

          this.khdq_options = res.data.data.map((item) => {
            return { value: item.dm, label: item.mc };
          });
        });
    },
    khdqchange: function (result) {
      if (this.bjkhdq != result) {
        this.options.khfz = "";
      }
      this.$axios
        .get(
          "api/system/rywh/get-rywh-khfz?khbh=" +
            this.options.khbh +
            "&khdq=" +
            this.options.khdq
        )
        .then((res) => {
          let self = this;
          self.khfz_options = res.data.data.map((item) => {
            if (item.fzmc != "") {
              return { value: item.fzmc, label: item.fzmc };
            }
          });
        });
    },
    khfzchange: function () {
      this.$axios
        .get("api/system/rywh/get-rywh-khkq?id=" + this.options.khfz)
        .then((res) => {
          let self = this;
          if (!this.$route.query.gh) {
            self.options.kqgz = res.data.data.kqgz;
          }
        });
    },
    save() {
      if (!this.options.gh) {
        this.$message["error"]("请输入工号！");
        return;
      }
      if (this.options.gh.substring(0, 3) != "DFC") {
        this.$message["error"]("工号必须以DFC开头请正确输入！");
        return;
      }
      if (this.options.gh.substring(3, this.options.gh.length).length != 4) {
        this.$message["error"]("请正确输入工号！");
        return;
      }
      if (!this.options.xm.replace(/^\s+|\s+$/g,"")) {
        this.$message["error"]("请输入姓名！");
        return;
      }
      if (!this.options.sfzhm.replace(/^\s+|\s+$/g,"")) {
        this.$message["error"]("请输入身份证号码！");
        return;
      }
      if (this.options.sfzhm.replace(/^\s+|\s+$/g,"").length != 18) {
        this.$message["error"]("请正确输入18位身份证号码！");
        return;
      }
      if (!this.options.lxdh.replace(/^\s+|\s+$/g,"")) {
        this.$message["error"]("请输入联系电话！");
        return;
      }
      // let reg = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/;
      // if (!reg.test(this.options.lxdh.replace(/^\s+|\s+$/g,""))) {
      //   this.$message["error"]("请正确输入11位联系电话！");
      //   return;
      // }
      if (!this.options.rzrq) {
        this.$message["error"]("请选择入职日期！");
        return;
      }
      if (!this.options.zw.replace(/^\s+|\s+$/g,"")) {
        this.$message["error"]("请输入职位！");
        return;
      }
      if (!this.options.khbh) {
        this.$message["error"]("请选择入职单位！");
        return;
      }
      if (!this.options.khdq) {
        this.$message["error"]("请选择客户地区！");
        return;
      }
      if (!this.options.kqgz) {
        this.$message["error"]("请选择考勤规则！");
        return;
      }
      if (!this.options.dllx) {
        this.$message["error"]("请选择登入类型！");
        return;
      }
      if (!this.options.yhm.replace(/^\s+|\s+$/g,"")) {
        this.$message["error"]("请输入用户名！");
        return;
      }
      if (!this.$route.query.gh) {
        if (!this.options.mm) {
          this.$message["error"]("请输入密码！");
          return;
        }
        if (this.options.mm != this.options.qrmm) {
          this.$message["error"]("确认密码不一致请重新输入！");
          return;
        }
      }

      if (this.options.xybz) {
        this.options.xybz = "1";
      } else {
        this.options.xybz = "0";
      }
      if (this.$route.query.gh) {
        this.$axios
          .get("api/system/rywh/get-rywh-xgyhm?yhm=" + this.options.yhm)
          .then((res) => {
            if (res.data.message == 1) {
              this.$axios
                .post("api/system/rywh/update-rywh-first", this.options)
                .then((res) => {
                  if (res.data.code == 200) {
                    this.$message["success"](res.data.message);
                    xadmin.close();
                    // xadmin.father_reload();
                  } else {
                    this.$message["error"](res.data.message);
                  }
                });
            } else {
              this.$message["error"]("用户名已存在请重新输入！");
              return;
            }
          });
      } else {
        this.$axios
          .get("api/system/rywh/get-rywh-gh?gh=" + this.options.gh)
          .then((res) => {
            if (res.data.message == 1) {
              this.$axios
                .get("api/system/rywh/get-rywh-yhm?yhm=" + this.options.yhm)
                .then((res) => {
                  if (res.data.message == 1) {
                    this.$axios
                      .post("api/system/rywh/set-rywh-first", this.options)
                      .then((res) => {
                        if (res.data.code == 200) {
                          this.$message["success"](res.data.message);
                          xadmin.close();
                          // xadmin.father_reload();
                        } else {
                          this.$message["error"](res.data.message);
                        }
                      });
                  } else {
                    this.$message["error"]("用户名已存在请重新输入！");
                    return;
                  }
                });
            } else {
              this.$message["error"]("工号已存在请重新输入！");
              return;
            }
          });
      }
    },
    cancel: function () {
      xadmin.close();
      //xadmin.father_reload();
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/rywhadd.vue